import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3l12 0","key":"svg-0"}],["path",{"d":"M7 15h5","key":"svg-1"}],["path",{"d":"M15 15h2","key":"svg-2"}],["path",{"d":"M17 12h-3","key":"svg-3"}],["path",{"d":"M11 12h-1","key":"svg-4"}]]

const IconSubtitles = createReactComponent('outline', 'subtitles', 'Subtitles', __iconNode);

export default IconSubtitles;